var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Account',{attrs:{"title":"Organisation activity"}},[_c('AccountHistoryOrgTabs',_vm._b({on:{"change":function($event){_vm.tab = $event}}},'AccountHistoryOrgTabs',{ tab: _vm.tab },false)),(_vm.tab === 'summary')?_c('AccountAdminBranchUsage'):_vm._e(),(_vm.tab === 'detail')?_c('AccountHistoryTable',{attrs:{"depth":"org"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }